export { default as Return } from './containers/ReturnContainer'



// WEBPACK FOOTER //
// ./src/ReturnGoods/index.js